module.exports = __webpack_public_path__ + "img/finland-cardiovascular-diseases-male.084fd739.png";